import { observer } from 'mobx-react';
import { Banner } from '.';
import { Flex } from '@mantine/core';
import instagram from '../../assets/social-media/scc-instagram.png';
import follow_us from '../../assets/social-media/insta-mobile-btn.png';
import { useWindowSize } from '../../hooks';
import { Link } from 'react-router-dom';

const instaLink = 'https://www.instagram.com/pilotversuche.research/';

export const InstagramBanner = observer(
  ({ maxWidth = '1100px' }: { maxWidth?: string }) => {
    const isSmallScreen = useWindowSize(750);

    return (
      <Banner
        padding="0px"
        innerPadding="0px"
        maxWidth={maxWidth}
        minWidth={'100px'}
        color={'transparent'}
      >
        <Flex gap={0} p="0px" m="0px">
          {isSmallScreen ? (
            <Link
              to={instaLink}
              target={'_blank'}
              style={{ margin: '0 20px', padding: 0 }}
            >
              <img
                height={'60px'}
                src={follow_us}
                alt="Instagram icon"
                style={{ color: '#fff' }}
              />
            </Link>
          ) : (
            <img
              height={'180px'}
              src={instagram}
              alt="Instagram icon"
              style={{ color: '#fff' }}
              onClick={() => window.open(instaLink, '_blank')}
            />
          )}
        </Flex>
      </Banner>
    );
  },
);
